// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13MDn","requiredAsterisk":"Info_requiredAsterisk__2lyxc"};